module.exports = __webpack_public_path__ + "img/tutorial03.fc5e7e71.svg";